import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';
import { stringUcFirst } from '../../../utils/stringUcFirst.js';

const COITable = ({
  candidates,
  committeeMembers,
  getCOIForCandidateAndMember,
}) => {
  const sortedMembers = useMemo(
    () => [...committeeMembers].sort((a, b) => a.name.localeCompare(b.name)),
    [committeeMembers],
  );

  if (candidates.length === 0) {
    return (
      <div className="text-center text-muted">
        No COIs declared for this committee yet
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <Table bordered hover className="coi-report-table">
        <thead className="thead-dark">
          <tr>
            <th style={{ minWidth: '150px' }}>
              <strong>Candidate Name</strong>
            </th>
            <th style={{ minWidth: '100px' }}>
              <strong>Conflict</strong>
            </th>
            {sortedMembers.map((member) => (
              <th key={member.id} style={{ minWidth: '150px' }}>
                <strong>
                  {member.name}
                  {member.isChair && ' (Chair)'}
                </strong>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {candidates.map((candidate) => (
            <React.Fragment key={candidate.id}>
              <tr>
                <td rowSpan="2" className="align-middle bg-light">
                  <strong>{candidate.name}</strong>
                </td>
                <td
                  className="align-middle bg-light"
                  style={{ padding: '20px' }}
                >
                  <strong>Type</strong>
                </td>
                {sortedMembers.map((member) => {
                  const coi = getCOIForCandidateAndMember(
                    candidate.id,
                    member.id,
                  );
                  return (
                    <td
                      key={`${candidate.id}-${member.id}-type`}
                      className="small standard-cell-width"
                      aria-label="Conflict of interest types"
                    >
                      {coi.category && (
                        <>
                          <strong>{`${stringUcFirst(coi?.category)}`}</strong>
                          {': '}
                        </>
                      )}
                      <div
                        dangerouslySetInnerHTML={{
                          __html: coi.types || '',
                        }}
                      />
                    </td>
                  );
                })}
              </tr>
              <tr>
                <td className="align-middle bg-light">
                  <strong>Detail</strong>
                </td>
                {sortedMembers.map((member) => {
                  const coi = getCOIForCandidateAndMember(
                    candidate.id,
                    member.id,
                  );
                  return (
                    <td
                      key={`${candidate.id}-${member.id}-detail`}
                      className="small standard-cell-width"
                    >
                      {coi.detail || ''}
                    </td>
                  );
                })}
              </tr>
            </React.Fragment>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

COITable.propTypes = {
  candidates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  committeeMembers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      isChair: PropTypes.bool.isRequired,
    }),
  ).isRequired,
  getCOIForCandidateAndMember: PropTypes.func.isRequired,
};

export default COITable;
